import PlayArrow from '@mui/icons-material/PlayArrow';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { Icon } from '@/components/shared/icon';

export const AccessCourse = ({ offerId }: { offerId?: number }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const route = offerId ? `/meu-aprendizado/curso/${offerId}` : null;
    if (!route) return;
    navigate(route);
  };

  return (
    <Box textAlign="center">
      <Icon name="check-icon" />
      <Typography variant="h3" my={2}>
        Matrícula realizada!
      </Typography>
      <Button fullWidth onClick={handleClick} variant="contained">
        <PlayArrow sx={{ mr: 1 }} /> Acessar o curso
      </Button>
    </Box>
  );
};
